import { render, staticRenderFns } from "./PreguntasCantidadRespuestas.vue?vue&type=template&id=3c121dde&scoped=true"
import script from "./PreguntasCantidadRespuestas.vue?vue&type=script&lang=js"
export * from "./PreguntasCantidadRespuestas.vue?vue&type=script&lang=js"
import style0 from "./PreguntasCantidadRespuestas.vue?vue&type=style&index=0&id=3c121dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c121dde",
  null
  
)

export default component.exports